'use client'
import { cloneElement, CSSProperties, ReactElement, ReactNode, useRef, useState, useLayoutEffect } from 'react'
import { useOnClickOutside, useToggle } from '~/hooks'
import { Container, Drop } from './styles'
import { createPortal } from 'react-dom'

type DropdownProps = {
  elementClick: ReactElement<React.ComponentPropsWithoutRef<'div'>>,
  children: ReactNode,
  $minWidht?: CSSProperties['minWidth']
  $options?: {
    top?: string,
    left?: string
  }
  $usePortal?: boolean
}

export const Dropdown: React.FC<DropdownProps> = ({ children, elementClick, $options, $minWidht, $usePortal }) => {
  const ref = useRef<HTMLDivElement>(null)
  const [coords, setCoords] = useState<{ top: number; left: number }>({ top: 0, left: 0 })
  const { toggle, isTrue, setIsTrue } = useToggle()

  useOnClickOutside(ref, () => setIsTrue(false))

  // calcula a posição do trigger (elementClick) na tela
  useLayoutEffect(() => {
    if (isTrue && ref.current) {
      const rect = ref.current.getBoundingClientRect()
      setCoords({
        top: rect.bottom + window.scrollY, // embaixo do botão
        left: rect.left + window.scrollX,  // alinhado ao botão
      })
    }
  }, [isTrue])

  return (
    <Container ref={ref} $isTrue={isTrue}>
      {cloneElement(elementClick, { onClick: toggle })}
      {isTrue &&
        ($usePortal
          ? createPortal(
            <Drop
              $minWidht={$minWidht}
              $isTrue={isTrue}
              $options={undefined} // vamos usar coords calculados
              style={{
                position: 'absolute',
                top: coords.top,
                left: coords.left - 162,
                zIndex: 99999, // sempre acima de tudo
              }}
            >
              {children}
            </Drop>,
            document.body
          )
          : (
            <Drop $minWidht={$minWidht} $isTrue={isTrue} $options={$options}>
              {children}
            </Drop>
          )
        )
      }
    </Container>
  )
}
